import { render } from "./IconExclamation.vue?vue&type=template&id=64759fde&ts=true"
import script from "./IconExclamation.vue?vue&type=script&lang=ts"
export * from "./IconExclamation.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/paulbele/Code/repositories/maatoo-app-master/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__